import axios from "axios";
import store from "./store";
import { clearCredentials } from "./authSlice";

const checkAuth = () => {
  const PUBLIC_ROUTES = [
    "login",
    "forgot-password",
    "register",
    "documentation",
  ];

  const isPublicPage = PUBLIC_ROUTES.some((r) =>
    window.location.href.includes(r),
  );

  if (!isPublicPage) {
    // Request interceptor — injects the latest in-memory token before every
    // axios request.  Reading from the store (not a captured closure) means
    // the header stays correct after a silent token refresh.
    axios.interceptors.request.use(
      function (config) {
        document.body.classList.add("loading-indicator");
        const token = store.getState().auth.token;
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      },
    );

    axios.interceptors.response.use(
      function (response) {
        document.body.classList.remove("loading-indicator");
        return response;
      },
      function (error) {
        document.body.classList.remove("loading-indicator");

        // For axios-based requests (S3/upload endpoints), treat 401 as a
        // hard session failure.  Token refresh is handled by apiSlice for
        // RTK Query endpoints.
        if (error.response && error.response.status === 401) {
          store.dispatch(clearCredentials());
          window.location.replace("/login?reason=session_expired");
        }

        return Promise.reject(error);
      },
    );
  }
};

export default checkAuth;
